<fgb-page-header [pageTitle]="'payment.page.title'" [backButtonLink]="'/payment'"></fgb-page-header>
<div class="container">
  <div class="card mx-lg-auto border-secondary bg-primary">
    <div class="card-body text-center py-3 px-0">
      <div class="card-heading d-flex align-items-center">
        <span class="material-icons text-white me-2"> add_card </span>
        <span class="text-white font-size-20 font-heading fw-bold text-uppercase">{{
          'ecash.success.page.title' | translate
        }}</span>
      </div>
      <div class="mt-4 sub-heading-modal">
        <div class="text-center font-praktika-normal text-white">{{ 'ecash.success.page.card.added' | translate }}</div>
      </div>

      <div class="btn-container mt-2 d-block">
        <button
          [routerLink]="['/payment']"
          type="button"
          class="btn text-white btn-primary bg-secondary border-secondary mt-4 fw-bold"
        >
          {{ 'ecash.success.page.close.button' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
